<template>
    <div>
        <table class="at-table full-with">
            <thead>
                <tr>
                    <th>预约项目名称</th>
                    <th style="width: 100px">预约次数</th>
                    <th style="width: 150px">赠送时间</th>
                    <th style="width: 104px">操作</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in appointment" :key="index">
                    <td style="padding: 8px">
                        <a-select v-model="item.id" class="full-with at-select" show-search :filter-option="false" @search="handleSearch">
                            <template v-for="(option) in appointmentList">
                                <a-select-option :value="option.id" :key="option.id">{{ option.name }}</a-select-option>
                            </template>
                        </a-select>
                    </td>
                    <td>
                        <a-input v-model="item.count" type="number" class="at-input text-center" />
                    </td>
                    <td>
                        <days-select v-model="item.day" :show-zero="false"></days-select>
                    </td>
                    <td>
                        <button class="btn btn-danger outline" @click="removeRow(index)">删除</button>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th colspan="3">
                        <button class="btn" @click="addRow">添加赠送预约项目</button>
                    </th>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
    import api from "@/repo/api";
    import DaysSelect from "@/components/DaysSelect.vue";
    
    export default {
        name:"CourseAppointmentBranchPicker",
        components: {DaysSelect},
        props:{
            appointment: {
                type:Array,
            }
        },
        model:{
            prop:'appointment',
            event:'change'
        },
        data(){
            return {
                appointmentList:[],
                query:{
                
                },
            }
        },
        mounted() {
            this.fetchCourse()
        },
        methods:{
            fetchCourse(){
                return new Promise((resolve, reject) => {
                    api.get('/ast-appointment/appointment-list', this.query, (data) => {
                        if (data.code != 0) {
                            reject(data.msg)
                            return
                        }
                        this.appointmentList = data.data.data
                        resolve()
                    })
                })
            },
            handleSearch(val){
                this.query.keywords = val
                this.fetchCourse()
            },
            addRow(){
                let appointment = this.appointment ? [...this.appointment] : []
                appointment.push({
                    id: '',
                    day: '',
                })
                this.$emit('change', appointment)
            },
            removeRow(row){
                let appointment = this.appointment ? [...this.appointment] : []
                let idx = appointment.findIndex((item) => item.id == row.id)
                appointment.splice(idx, 1)
                this.$emit('change', appointment)
            }
        }
    }
</script>

<style></style>